import { useMutation } from "@tanstack/react-query";
import {
  CheckoutFreightClient,
  CreateQuoteAddressDto,
  FreightLineItemDto,
  ShippingMethodDto,
  ShippingMethodsRequestDto,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";

export interface ShippingCheckItem {
  productDescriptor: string;
  productClass: string;
  unitPrice: number;
  quantity: number;
  /** Cart line the item came from; a saved-quote cart line is then priced and weighed from its quote. */
  sourceCartLineNumber?: number;
  /** The saved-quote item the user reviewed on that cart line; the server rejects the request if the cart line changed. */
  sourceQuoteItemDescriptor?: string;
}

export interface ShippingMethodCheckVariables {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
  items: ShippingCheckItem[];
}

export default function useGetShippingMethods() {
  const api = useApi(CheckoutFreightClient);

  return useMutation<ShippingMethodDto[], Error, ShippingMethodCheckVariables>({
    mutationFn: (vars) =>
      api.getShippingMethods(
        new ShippingMethodsRequestDto({
          shipTo: new CreateQuoteAddressDto({
            street: vars.street,
            city: vars.city,
            stateProvince: vars.state,
            postalCode: vars.postalCode,
            country: vars.countryCode,
          }),
          items: vars.items.map(
            (item) =>
              new FreightLineItemDto({
                productDescriptor: item.productDescriptor,
                productClass: item.productClass,
                unitPrice: item.unitPrice,
                quantity: item.quantity,
                sourceCartLineNumber: item.sourceCartLineNumber,
                sourceQuoteItemDescriptor: item.sourceQuoteItemDescriptor,
              }),
          ),
        }),
      ),
  });
}
